import api from "../controllers/api";

export const vehicleAssign = async (data) => {
  // sample payload data
  // [
  //     {
  //         "driver_id": "1d144c98-4f0b-43ff-91b3-ed83cc330d3d",
  //         "new_vehicle_id": "5f80151a-9595-4a32-9107-9b4680296225",
  //         "request_reason": "svdd cdsv",
  //         "request_remarks": "sdv svf d"
  //     }
  // ]
  try {
    const url = `/fleet/vehicleAssign`;
    const result = await api.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getAssignVehicleAPI = async (driverId) => {
  try {
    const url = `/fleet/getDriverAssignToVehicle/${driverId}`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
